import React, { useState } from 'react'
import Collapsible from 'react-collapsible'
import { BsScissors } from 'react-icons/bs'
import styles from '../Components/Skills.module.css'


const Skills = (props) => {
    const { data } = props;
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className={styles.mainWrapper}>
            <Collapsible trigger={
                <div className={isOpen === true ? styles.mainHeaderOpen : styles.mainHeader}>
                    <div className={styles.leftCol}>
                        <BsScissors />
                        <span className={styles.headerTitle}>
                            Skills
                        </span>
                    </div>
                    <div className={styles.rightCol}>

                    </div>
                </div>
            }
                isOpen={false}
                onOpening={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
            >

                <div className={styles.mainContainer}>
                    {data?.map((item, index) => (
                        <div className={styles.eachSkill} key={index}>
                            {item?.skill}
                        </div>
                    ))}

                </div>
            </Collapsible>
        </div>
    )
}

export default Skills